import { CountryCoverage } from '../country-coverage.interface';

export const COMPANIES_HOUSE_COUNTRIES: CountryCoverage[] = [
  {
    // Great Britain
    code: 'GB',
  },
];
